var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5273 8.23439C18.5619 9.16631 19.8993 9.16561 19.9336 8.23439V5.33545L18.5273 5.84943V8.23439Z",
    fill: "#5D7285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52886 4.0074L11.7565 6.65091C11.9124 6.70796 12.0834 6.70796 12.2394 6.65101L19.4718 4.00749C20.0835 3.7846 20.0833 2.90945 19.4719 2.6867L12.2418 0.0432734C12.0859 -0.0137734 11.9149 -0.0137734 11.759 0.0432734L4.52896 2.6867C3.91733 2.90954 3.91756 3.78465 4.52886 4.0074Z",
    fill: "#5D7285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15483 15.3391C7.15483 14.024 6.08491 12.9541 4.76983 12.9541C1.61013 13.074 1.61102 17.6047 4.76988 17.7241C6.08491 17.7241 7.15483 16.6542 7.15483 15.3391Z",
    fill: "#5D7285"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6158 15.3391C21.6158 14.024 20.5458 12.9541 19.2308 12.9541C16.0711 13.074 16.072 17.6047 19.2308 17.7241C20.5458 17.7241 21.6158 16.6542 21.6158 15.3391Z",
    fill: "#5D7285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61523 15.3391C9.61523 16.6542 10.6852 17.7241 12.0002 17.7241C15.1599 17.6042 15.1591 13.0735 12.0002 12.9541C10.6852 12.9541 9.61523 14.024 9.61523 15.3391Z",
    fill: "#5D7285"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2306 17.7241C18.2889 17.7241 17.4102 17.9985 16.6699 18.4714C17.6056 19.5529 18.172 20.9589 18.172 22.4941V24.0004H23.2975C23.6858 24.0004 24.0006 23.6855 24.0006 23.2972V22.4941C24.0006 19.8639 21.8608 17.7241 19.2306 17.7241Z",
    fill: "#5D7285"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9595 17.7241C9.30989 17.7241 7.1543 19.8639 7.1543 22.4941V24.0004H16.7647V22.4941C16.7646 19.8639 14.609 17.7241 11.9595 17.7241Z",
    fill: "#5D7285"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 17.7241C2.1398 17.7241 0 19.8639 0 22.4941V23.2972C0 23.6855 0.314812 24.0004 0.703125 24.0004H5.74861V22.4941C5.74861 20.9435 6.32639 19.5247 7.27889 18.439C6.54956 17.9861 5.68983 17.7241 4.77 17.7241Z",
    fill: "#5D7285"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4687 9.11704V6.60205L12.7217 7.9716C12.2575 8.14246 11.7364 8.14246 11.2725 7.97118L7.53125 6.60285V9.11778C7.53125 9.413 7.71566 9.67677 7.99287 9.77811L11.7561 11.1545C11.912 11.2115 12.083 11.2115 12.239 11.1545L16.007 9.77746C16.2842 9.67611 16.4687 9.4123 16.4687 9.11704Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStudents);
export default __webpack_public_path__ + "static/media/new_students.b5c8460681ed0a1436a09b0d3371a095.svg";
export { ForwardRef as ReactComponent };